import type { FC } from 'react';
import type { ValidateResult } from 'react-hook-form';

import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { selectOneFieldComparisonValidatorFunction } from '@/services/validators';

export function withSelectOneFieldComparisonValidation( WrappedComponent: FC<ValidatedComponentProps> ) {
	const NewComponent = ( props: ValidatedComponentProps ) => {
		const { question, validators } = props;
		const { getValues } = useFormContext();

		const matchedValidators = useMemo( () => {
			return validators.filter( validator => validator.fieldType === 'SelectOneFieldComparison' );
		}, [ validators ] );

		const validationObject = useMemo( () => {
			const returnValue: Record<string, ( v: string ) => ValidateResult> = { ...question.validate };

			matchedValidators.forEach( ( validator, index ) => {
				returnValue[ `comparison${ index }` ] = ( v: string ) => {
					return selectOneFieldComparisonValidatorFunction( validator as SelectOneFieldComparison, question, getValues );
				};
			});

			return returnValue;
		}, [ getValues, matchedValidators, question ] );

		return (
			<WrappedComponent
				{ ...props }
				question={{
					...question,
					validate: validationObject
				}}
			/>
		);
	};

	NewComponent.displayName = 'withSelectOneFieldComparisonValidation';

	return NewComponent;
}
